import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import AttendeesListItem from './AttendeesListItem.vue'
import PictureViewer from '@/components/PictureViewer.vue'
import { User } from '@/types/user'

interface ManageAttendeesListProps {
  attendees: User[]
  pendingAttendees: User[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttendeesList',
  props: {
    attendees: null,
    pendingAttendees: null
  },
  setup(__props: any) {



// Picture Viewer functionality ------------------------------------------------

const attendeePictureUrl = ref<string[]>([])
const showLightBox = ref(false)

function showProfilePicture(picture: string) {
  if (picture) {
    attendeePictureUrl.value = [picture]
    showLightBox.value = true
  }
}

return { __sfc: true,attendeePictureUrl, showLightBox, showProfilePicture, AttendeesListItem, PictureViewer }
}

})